import { useState } from "react";
import { motion as m } from "framer-motion";
import Modal from "./Modal";
import { TickCircle } from "iconsax-react";
import axios from "axios";
import { useToast } from "./Toast";
import { GET_TABLE_GUESTS_API } from "../Constant/api";

const TableGuestList = ({
  tableId,
  guestInfo,
  isOpen,
  toggleModal,
  onSelectGuest,
}) => {
  const [tableGuests, setTableGuests] = useState([]);
  const [listOpen, setListOpen] = useState(false); // Just like SeatManagement
  const { toast } = useToast();

  const getTableId = () => tableId || guestInfo?.table_id;

  const handleViewGuests = () => {
    const id = getTableId();
    if (!id) return;

    axios
      .get(GET_TABLE_GUESTS_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: {
          tableId: id,
          eventId: sessionStorage.getItem("event_id"),
        },
      })
      .then((response) => {
        setTableGuests(response.data.data || []);
        setListOpen(true);
      })
      .catch((error) => {
        toast("Failed to fetch table guests", "error");
        console.error(error);
      });
  };

  if (!listOpen) {
    if (isOpen) {
      handleViewGuests();
    }
    return null;
  }

  return (
    <Modal
      title="Guest List"
      toggleModal={() => {
        setListOpen(false);
        toggleModal();
      }}
    >
      <m.div
        className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl text-nowrap"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {tableGuests.length > 0 ? (
          <>
            <div className="flex w-full border-b p-[16px] items-center">
              <h1 className="flex w-full justify-start">Guest Name</h1>
              <h1 className="flex w-full justify-end">Check In</h1>
            </div>

            {tableGuests.map((item, index) => (
              <div
                key={index}
                className={`flex w-full p-[16px] items-center border-b last:border-none 
                                    ${
                                      onSelectGuest
                                        ? "hover:bg-[#F7F8FA] hover:cursor-pointer"
                                        : ""
                                    }`}
                onClick={() => {
                  if (onSelectGuest) {
                    onSelectGuest(item.uuid);
                    setListOpen(false);
                    toggleModal();
                  }
                }}
              >
                <p className="flex w-full justify-start font-normal">
                  {index + 1}. {item.guest_name}
                </p>

                <p className="flex w-full justify-end font-normal">
                  {item.guest_status && (
                    <TickCircle size="24" color="#37D67A" variant="Bold" />
                  )}
                </p>
              </div>
            ))}
          </>
        ) : (
          <div className="flex flex-col justify-center items-center p-[36px]">
            <h1 className="text-[20px] text-gray-500">
              No guests assigned to this table
            </h1>
          </div>
        )}
      </m.div>
    </Modal>
  );
};

export default TableGuestList;
